const styles = theme => ({
  // All Plans Include section
  allPlansRoot: {
    width: '100%',
    maxWidth: 1280,
    border: '1px solid #E5E7EB',
    borderRadius: 16,
    padding: '32px 40px',
    marginBottom: 32,
    boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.12), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
  },
  allPlansCaption: {
    color: 'var(--mcg-colors-mcg-gray, #637381)',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '-0.32px',
    marginBottom: 8,
  },
  allPlansTitle: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '36px',
    letterSpacing: '-0.64px',
    marginBottom: 24,
  },
  allPlansTitleHighlight: {
    backgroundImage: 'linear-gradient(transparent 60%, #FCD34D 60%)',
    paddingBottom: 2,
  },
  allPlansGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px 48px',
    '@media (max-width: 768px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    '@media (max-width: 480px)': {
      gridTemplateColumns: '1fr',
    },
  },
  allPlansItem: {
    display: 'flex',
    alignItems: 'center',
  },
  blueCheckCircle: {
    width: '16.8px',
    height: '16.8px',
    minWidth: '16.8px',
    aspectRatio: '1/1',
    borderRadius: '50%',
    backgroundColor: '#015FFB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  allPlansText: {
    fontSize: '15px',
    color: '#002E47',
    fontFamily: 'Inter',
  },

  // Pricing card styles
  cardRoot: {
    width: '100%',
    maxWidth: 302,
    minWidth: 254,
    minHeight: 580,
    padding: '32px 24px',
    borderRadius: 16,
    border: '1px solid #E5E7EB',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: 32,
    backgroundColor: '#fff',
    boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.12), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
    transition: 'box-shadow 0.2s ease',
    '&:hover': {
      boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.2)',
    },
  },
  // Enterprise plans list fewer features, so they don't need the taller card
  cardRootEnterprise: {
    minHeight: 500,
  },
  cardCaption: {
    color: 'var(--Color---Dark, #637381)',
    fontFamily: 'Inter',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: '-0.26px',
    marginBottom: 4,
  },
  cardSubscription: {
    color: '#0B1D2E',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '36px',
    letterSpacing: '-0.48px',
    marginBottom: 20,
  },
  priceRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 2,
    marginBottom: 4,
  },
  dollarSign: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#002E47',
    fontFamily: 'Inter',
  },
  priceValue: {
    fontSize: '48px',
    fontWeight: 700,
    color: '#002E47',
    fontFamily: 'Inter',
    lineHeight: 1,
  },
  priceMonth: {
    fontSize: '14px',
    color: '#637381',
    fontFamily: 'Inter',
  },
  letsTalkText: {
    color: '#0B1D2E',
    fontFamily: 'Inter',
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: 800,
    lineHeight: '48px',
  },
  savingsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    marginTop: 20,
    marginBottom: 8,
    backgroundColor: '#EFFCEF',
    borderRadius: 20,
    padding: '4px 8px',
  },
  savingsCheck: {
    fontSize: '12px',
    color: '#02791A',
    fontWeight: 600,
  },
  savingsText: {
    color: '#02791A',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '150%',
  },
  tailoredText: {
    color: '#637381',
    fontFamily: 'Inter',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '150%',
    letterSpacing: '-0.26px',
    marginBottom: 40,
  },
  divider: {
    width: '100%',
    height: 1,
    backgroundColor: '#E5E7EB',
    margin: '16px 0',
  },
  featuresLead: {
    color: '#0B1D2E',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    marginBottom: 12,
  },
  featureList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  featureItem: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  featureText: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%',
  },
  upgradeButton: {
    backgroundColor: '#015FFB',
    color: '#fff',
    borderRadius: 24,
    textTransform: 'none',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '15px',
    padding: '12px 24px',
    boxShadow: 'none',
    // `&&` outranks CoreButton's own hover rule, which would otherwise keep
    // the base blue and add a shadow. Matches the website's brand-dark hover.
    '&&:hover': {
      backgroundColor: '#034894',
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      backgroundColor: '#E5E7EB',
      color: '#9CA3AF',
    },
  },
  demoButton: {
    borderColor: '#002E47',
    color: '#002E47',
    borderRadius: 24,
    textTransform: 'none',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '14px',
    padding: '10px 24px',
    '&:hover': {
      borderColor: '#002E47',
      backgroundColor: 'rgba(0, 46, 71, 0.04)',
    },
  },
})

export default styles
